import { useEffect, useState } from "react";
import useStructureQueries from "hooks/useStructureQueries";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  Card,
  CardMedia,
} from "@material-ui/core";
import EmailText from "components/_refactor/text/email";
import PhoneText from "components/_refactor/text/phone";
import { Close, Handshake } from "@mui/icons-material";
import karstenImage from "assets/img/logos/karstenWhite.webp";
import trussardiImage from "assets/img/logos/trussardiWhite.webp";
import KarstenDecorImage from "assets/img/logos/karstenDecor.webp";
import LoadingData from "components/Loading/LoadingData";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

export default function RepresentativesCard({
  storeId,
  setOpenedModal,
  setType,
}) {
  const [searching, setSearching] = useState(false);
  const [representantes, setRepresentantes] = useState();
  const [selectedRep, setSelectedRep] = useState();
  const snackbar = useSnackbar();
  const { getRepresentatives } = useStructureQueries();

  const handleSearch = async () => {
    setSearching(true);
    try {
      const [r1, r2, r3] = await Promise.all([
        getRepresentatives({ idPessoaLoja: storeId, idMarca: 1 }),
        getRepresentatives({ idPessoaLoja: storeId, idMarca: 2 }),
        getRepresentatives({ idPessoaLoja: storeId, idMarca: 3 }),
      ]);
      const representantesList = [
        ...(r1?.data ?? []),
        ...(r2?.data ?? []),
        ...(r3?.data ?? []),
      ];
      setRepresentantes(representantesList);
      setSelectedRep(representantesList[0] || null);
    } catch (error) {
      snackbar.showMessage("Erro ao buscar informações de representantes:", {
        severity: "error",
      });
    } finally {
      setSearching(false);
    }
  };

  const logos = {
    Karsten: karstenImage,
    Trussardi: trussardiImage,
    KarstenDecor: KarstenDecorImage,
  };

  const details = [
    { label: "Código ERP", value: selectedRep?.CodigoErp },
    { label: "CNPJ", value: selectedRep?.CNPJ },
    { label: "Razão Social", value: selectedRep?.Nome },
    { label: "Nome Contato", value: selectedRep?.Nome },
    { label: "Marca", value: selectedRep?.Marca },
    {
      label: "Telefone 1",
      value: <PhoneText phone={selectedRep?.Telefone1} />,
    },
    {
      label: "Telefone 2",
      value: <PhoneText phone={selectedRep?.Telefone2} />,
    },
    {
      label: "Email",
      value: <EmailText email={selectedRep?.Email} />,
    },
  ];

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <Dialog open onClose={() => setOpenedModal(null)} maxWidth={"md"} fullWidth>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <Handshake style={{ marginRight: "12px" }} />
            Representantes
          </Typography>
          <IconButton onClick={() => setOpenedModal(null)}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      {searching ? (
        <DialogContent>
          <LoadingData searching label="Buscando dados de representantes..." />
        </DialogContent>
      ) : (
        <DialogContent>
          <Grid container spacing={2}>
            {representantes?.map((rep) => (
              <Grid item xs={4} key={rep.id}>
                <Card
                  style={{
                    padding: "0 2rem",
                    border: `1px solid ${
                      selectedRep.id === rep.id ? "#13294B" : "#C2C2C2"
                    }`,
                    backgroundColor:
                      selectedRep.id === rep.id ? "#13294B" : "#C2C2C2",
                    cursor: "pointer",
                  }}
                  onClick={() => setSelectedRep(rep)}
                >
                  <CardMedia
                    component="img"
                    alt={rep.Marca}
                    height="60"
                    src={logos[rep.Marca.replace(" ", "")]}
                    title={rep.Marca}
                    style={{
                      objectFit: "contain",
                      padding: "8px",
                      filter:
                        selectedRep.id !== rep.id ? "grayscale(100%)" : "none",
                      opacity: selectedRep.id !== rep.id ? 0.6 : 1,
                    }}
                  />
                </Card>
              </Grid>
            ))}
          </Grid>

          <Grid container direction="column">
            <Grid item xs={12}>
              {details.map(({ label, value }) => (
                <Typography key={label} variant="caption">
                  <strong>{label}:</strong> {value}
                </Typography>
              ))}
            </Grid>
          </Grid>
        </DialogContent>
      )}
      <DialogActions>
        <Button
          variant="outlined"
          style={{ marginTop: "1.5rem" }}
          onClick={() => setOpenedModal(null)}
        >
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
